import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=228fe57c&scoped=true"
import script from "./SignInPage.vue?vue&type=script&lang=js"
export * from "./SignInPage.vue?vue&type=script&lang=js"
import style0 from "./SignInPage.vue?vue&type=style&index=0&id=228fe57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fe57c",
  null
  
)

export default component.exports